var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67439 3.78809H3.39661C2.99668 3.78809 2.61313 3.93974 2.33034 4.20967C2.04754 4.47961 1.88867 4.84573 1.88867 5.22748V15.3032C1.88867 15.685 2.04754 16.0511 2.33034 16.321C2.61313 16.591 2.99668 16.7426 3.39661 16.7426H13.9522C14.3521 16.7426 14.7356 16.591 15.0184 16.321C15.3012 16.0511 15.4601 15.685 15.4601 15.3032V10.2654",
    stroke: "#425364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3293 2.70888C14.6292 2.42257 15.036 2.26172 15.4602 2.26172C15.8844 2.26172 16.2912 2.42257 16.5912 2.70888C16.8911 2.99519 17.0596 3.38352 17.0596 3.78843C17.0596 4.19333 16.8911 4.58166 16.5912 4.86797L9.42847 11.7051L6.4126 12.4248L7.16657 9.546L14.3293 2.70888Z",
    stroke: "#425364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1d4ae13ba836acb66ecc13cd4652e4fe.svg";
export { ForwardRef as ReactComponent };